import React, { useState, useContext, useEffect } from 'react';

import { Modal, Button, Toast,
			Accordion, AccordionContext 
		} from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

import Verb from './Verb';
import Nominal from './Nominal';

import '../css/blocks.css';
import '../css/Components.css';

// Toast for interface (verb and morphological) errors
const InterfaceError =({showInterfaceError, setShowInterfaceError}) =>(
	<div className='toastContainer' hidden={!showInterfaceError}>
		<Toast show={showInterfaceError} bg='primary' className='toast'
				onClose={()=>setShowInterfaceError(false)}
		>
			<Toast.Header closeButton={true}>
				<p className='m-auto'>Incomplete inflection input</p>
			</Toast.Header>
			<Toast.Body className='toastBody'>Select an option for each category</Toast.Body>
		</Toast>
	</div>
);

const MorphologicalInterface=props=>{
	const [type, setType] =useState('Nominal');
	const [inputParts, setInputParts]=useState({'i':false});

	const [showInterfaceError, setShowInterfaceError]=useState(false);

	// Reset form each time the modal opens (not on every ansstate identity change).
	useEffect(() => {
		if (!props.show) return;
		setType('Nominal');
		setInputParts({ i: false });
		setShowInterfaceError(false);
	}, [props.show]);

	const [interfaceBtn, setInterfaceBtn] =useState(null)
	useEffect(() => {
		if (interfaceBtn){
			// create an eventListener
			window.addEventListener('keydown', e=>handleKeyDown(e));
			// cleanup this component
			return () => {
				window.removeEventListener('keydown', e=>handleKeyDown(e));
			};
		}
	}, [interfaceBtn]);
	const handleKeyDown=(event)=>{
		if(event.key==='Enter'){
			event.preventDefault();
			// console.log('MODAL Enter:')
			interfaceBtn.click();	
		}
	};
	

	// Used in submit button.
	// Uses `in` for key-presence checks so that any selected value (even ones
	// like '' or 'v' that could be falsy or look odd) counts as "filled".
	const isDisabled = () => {
		if (type === 'Nominal') {
			if (inputParts['i'] === true) return false;
			return !('gender' in inputParts
				&& 'case' in inputParts
				&& 'number' in inputParts);
		}
		if (type === 'Verb') {
			return !('tense' in inputParts
				&& 'voice' in inputParts
				&& 'person' in inputParts
				&& 'number' in inputParts);
		}
		return true;
	};

	// Update answer (inflection) and close modal
	const handleSubmit=async () =>{
		if (isDisabled()){
			setShowInterfaceError(true);
			return;
		}

		let input ="";
		if (type==='Nominal'){
			if (inputParts['i'])
				input = 'i'
			else
				input =inputParts['gender']+inputParts['case']+inputParts['number'];
		}
		else if(type==="Verb"){
			// Join only real values. A missing field stringifies as "undefined"
			// (e.g. undefined_a3s) if we use + concatenation.
			const tense = inputParts.tense ?? '';
			const voice = inputParts.voice ?? '';
			const person = inputParts.person ?? '';
			const number = inputParts.number ?? '';
			const root = inputParts.root ?? 'p';
			input = `${tense}_${voice}${person}${number}`;
			if (root !== 'p')
				input = `${root}_${input}`;
		}

		// Immutable update — mutating the existing row object made later
		// submits look unchanged (updated === previous), so the field stuck.
		const values = props.ansstate.map((row, i) =>
			i === props.index ? { ...row, inflection: input } : row
		);
		props.setans(values);
		props.onHide();
		return;
	};
	
	const CustomToggle = ({ btnPart, eventKey, callback }) => {
		const currentEventKey = useContext(AccordionContext);
		const isCurrentEventKey = currentEventKey.activeEventKey === eventKey;
		const decoratedOnClick = useAccordionButton(eventKey, 
			() => callback && callback(eventKey),
		);
	
		return (
			<Button key={btnPart} variant="outline-primary"
				active={isCurrentEventKey}
				onClick={() => {
					decoratedOnClick();
					// Only reset when the user is actually switching tabs.
					// Clicking the already-active tab must NOT wipe selections.
					if (btnPart !== type) {
						setType(btnPart);
						if (btnPart === 'Nominal')   setInputParts({ 'i': false });
						else if (btnPart === 'Verb') setInputParts({ 'root': 'p' });
					}
				}}>
				{btnPart}
			</Button>
		);
	}
	
	return(
		<>
		<Modal
			{...props}
			size="lg"
			centered
		>
			<InterfaceError showInterfaceError={showInterfaceError} setShowInterfaceError={setShowInterfaceError} />

			<Accordion defaultActiveKey={1}>
				
			<Modal.Header closeButton>
				<div className="widthVW interfaceTitle">
					{props.title}
				</div>
			</Modal.Header>
			
			<Modal.Body>
				<div className="widthVW mb-2">
					<CustomToggle key={1} btnPart="Nominal" eventKey={1} />
					<CustomToggle key={2} btnPart="Verb" eventKey={2} />
				</div>
				<Accordion.Collapse key={1} eventKey={1}>
					<Nominal inputParts={inputParts} setInputParts={setInputParts}/>
				</Accordion.Collapse>
				<Accordion.Collapse key={2} eventKey={2}>
					<Verb inputParts={inputParts} setInputParts={setInputParts}/>
				</Accordion.Collapse>
			</Modal.Body>
			{/* enabled = (i===true) or (i===false && #>=4) */}
			{/* disabled = (i===false && #<4) */}
			{/*console.log(inputParts['i'], Object.keys(inputParts), inputParts['i']===false 
														&& Object.keys(inputParts).length<4) */}
			<Modal.Footer>
				<Button variant="primary"
							ref ={node=>setInterfaceBtn(node)}
							onClick={handleSubmit}
				>
					Submit
				</Button>
				<Button onClick={()=>props.onHide()} variant="outline-danger">Close</Button>
			</Modal.Footer>

			</Accordion>
		</Modal>
		</>
	)
};

export default MorphologicalInterface;